const ConditionalDependenciesList = [
    {
        "sentry.bogcm.web": [
            "sentry.bogcm.view.all",
            "sentry.bogcm.view.subordinates",
            "sentry.bogcm.view.my",
            "sentry.bogcm.edit.all",
            "sentry.bogcm.edit.subordinates",
            "sentry.bogcm.edit.my",
            "sentry.bogcm.review.all",
            "sentry.bogcm.review.subordinates",
            "sentry.bogcm.evaluation.all",
            "sentry.bogcm.evaluation.subordinates",
        ]
    },
    {
        "sentry.bogcm.app": [
            "sentry.bogcm.view.all",
            "sentry.bogcm.view.subordinates",
            "sentry.bogcm.view.my",
            "sentry.bogcm.edit.all",
            "sentry.bogcm.edit.subordinates",
            "sentry.bogcm.edit.my",
            "sentry.bogcm.review.all",
            "sentry.bogcm.review.subordinates",
            "sentry.bogcm.evaluation.all",
            "sentry.bogcm.evaluation.subordinates",
        ]
    },
    {
        "sentry.bogcm.agent_app": [
            "sentry.bogcm.view.all",
            "sentry.bogcm.view.subordinates",
            "sentry.bogcm.view.my",
            "sentry.bogcm.edit.all",
            "sentry.bogcm.edit.subordinates",
            "sentry.bogcm.edit.my",
            "sentry.bogcm.review.all",
            "sentry.bogcm.review.subordinates",
            "sentry.bogcm.evaluation.all",
            "sentry.bogcm.evaluation.subordinates",
        ]
    },
    {
        "sentry.bogcm.edit.all": [
            "sentry.bogcm.reject",
            "sentry.bogcm.rectify",
            "sentry.bogcm.add_other_documents",
            "sentry.bogcm.invalidate",
            "sentry.search.cortex.individual",
            "sentry.bogcm.create.independent"
        ]
    },
    {
        "sentry.bogcm.edit.subordinates": [
            "sentry.bogcm.reject",
            "sentry.bogcm.rectify",
            "sentry.bogcm.add_other_documents",
            "sentry.bogcm.invalidate",
            "sentry.search.cortex.individual",
        ]
    },
    {
        "sentry.bogcm.edit.my": [
            "sentry.bogcm.rectify",
            "sentry.bogcm.add_other_documents",
            "sentry.bogcm.invalidate",
            "sentry.search.cortex.individual",
            "sentry.bogcm.create.independent"
        ]
    },
    {"sentry.bogcm.view.all": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.view.subordinates": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.view.my": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.edit.all": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.edit.subordinates": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.edit.my": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.create.independent": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.review.all": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.review.subordinates": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.evaluation.all": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.evaluation.subordinates": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.reject": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.rectify": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.add_other_documents": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {"sentry.bogcm.invalidate": ["sentry.bogcm.web", "sentry.bogcm.app"]},
    {
        "sentry.alarm.sign1.view": [
            "sentry.alarm.print",
            "sentry.sound.notifications.mute"
        ]
    },
    {"sentry.alarm.sign2": ["sentry.alarm.print"]},
    {"sentry.occurrence.tracking": ["sentry.sound.notifications.mute"]},
    {"sentry.occurrence.localpublic": ["sentry.occurrence", "sentry.occurrence.view"]},
    {"sentry.occurrence.localinteligence": ["sentry.occurrence", "sentry.occurrence.view"]},
    {"sentry.occurrence.mygroups": ["sentry.occurrence", "sentry.occurrence.view"]},
    {"sentry.occurrence.myuser": ["sentry.occurrence", "sentry.occurrence.view"]},
    {"sentry.occurrence.admin": ["sentry.occurrence", "sentry.occurrence.view"]},

    {"sentry.sos.manage.citizen": ["sentry.sos.citizen.history.edit"]},
    {"sentry.sos.manage.events": ["sentry.sos.citizen.history.edit"]},
    {"sentry.sos.view": ["sentry.sos.citizen.history.edit"]},

    {"sentry.sos.manage.all.program": [
            "sentry.sos.manage.citizen",
            "sentry.sos.receive_events_in_agent_app",
            "sentry.sos.view",
            "sentry.sos.manage.events",
            "sentry.sos.citizen.scheduled.visit.manage"
        ]
    },

    {"sentry.sos.manage.program": [
            "sentry.sos.manage.citizen",
            "sentry.sos.receive_events_in_agent_app",
            "sentry.sos.view",
            "sentry.sos.manage.events",
            "sentry.sos.citizen.scheduled.visit.manage"
        ]
    },

    {"sentry.sos.manage.citizen" : ["sentry.sos.manage.program"]},
    {"sentry.sos.manage.citizen" : ["sentry.sos.manage.all.program"]},
    {"sentry.sos.receive_events_in_agent_app" : ["sentry.sos.manage.program"]},
    {"sentry.sos.receive_events_in_agent_app" : ["sentry.sos.manage.all.program"]},
    {"sentry.sos.view" : ["sentry.sos.manage.program"]},
    {"sentry.sos.view" : ["sentry.sos.manage.all.program"]},
    {"sentry.sos.manage.events" : ["sentry.sos.manage.program"]},
    {"sentry.sos.manage.events" : ["sentry.sos.manage.all.program"]},
    {"sentry.sos.citizen.scheduled.visit.manage" : ["sentry.sos.manage.program"]},
    {"sentry.sos.citizen.scheduled.visit.manage" : ["sentry.sos.manage.all.program"]},

    {"sentry.sos.events.asset": ["sentry.sos.attachs.show"]},
    {"sentry.sos.events.non_asset": ["sentry.sos.attachs.show"]},
    {"sentry.sos.events.special_protection": ["sentry.sos.attachs.show"]},

    {
        "sentry.allow.lane.access": [
            "sentry.passage.search",
            "sentry.occurrence.mark",
            "sentry.occurrence.tracking",
            "sentry.alarm.sign1.view",
            "sentry.occurrence.mark"
        ]
    },

    {
        "sentry.allow.restricted.lane.access": [
            "sentry.passage.search",
            "sentry.occurrence.mark",
            "sentry.occurrence.tracking",
            "sentry.alarm.sign1.view",
            "sentry.occurrence.mark"
        ]
    },
    {
        "sentry.encounter.app" : [
            "sentry.encounter.edit",
            "sentry.blitz.app",
            "sentry.search.cortex.individual",
            "sentry.encounter.app.passage.search",
        ]
    },
    {
        "sentry.encounter.app.dispatch" : [
            "sentry.encounter.edit",
            "sentry.search.cortex.individual",
            "sentry.encounter.app.passage.search",
        ]
    },
    {
        "sentry.reference.vehicle": [
            "sentry.search.cortex.renavam"
        ]
    },
    {
        "sentry.individual.alarm": [
            "sentry.sign.individual.alarm",
            "sentry.mute.individual.alarm",
            "sentry.individual.passage.search"
        ]
    },
    {
        "sentry.individual.passage.search": [
            "sentry.individual.monitoring"
        ]
    },
    {"sentry.reference.individual": ["sentry.search.cortex.individual",]},
    {"sentry.dispatch.attendance.web": ["sentry.search.cortex.individual",]},
    {"sentry.dispatch.retroactive": ["sentry.search.cortex.individual",]},
    {"sentry.occurrence": ["sentry.search.cortex.individual",]},
];

export default ConditionalDependenciesList;